import api from '../../../api';

export const getEspLimits = async () => api.get('/email-account/esp-limits');

export const updateMaxSendingLimit = async ({ emailAccountId, limit }) =>
  api.patch(`/email-account/max-sending-limit/${emailAccountId}`, { limit });

export const updateInboxPlacementMaxSendingLimit = async ({
  emailAccountId,
  limit,
}) =>
  api.patch(
    `/email-account/inbox-placement-daily-sending-limit/${emailAccountId}`,
    { limit },
  );

export const updateSendingLimits = async ({ emailAccountId, payload }) =>
  api.patch(`/email-account/sending-limits/${emailAccountId}`, payload);
